exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-pills li {\n    margin: 1px;\n    padding: 1px;\n}\n\n.nopadding {\n   padding: 0.4% !important;\n   margin: 0 !important;\n}\n.margin-pannel{\n  padding: 0.2%;\n}\n\n.tradingview{\n height: 500px;\n}\n\n.input-group{\n  margin: 2%;\n}\n\n.btn-cal-func{\n  margin-top: 1%;\n  margin-bottom: 1%;\n}\n\n.logo{\n  position: absolute;\n  margin-top: -0.60%;\n  margin-left: 0.2%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader!./app/css/bootstrap-custom.css
// module id = 231
// module chunks = 0